/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 発注先に自社センターを含む
 * @export
 * @interface InternalInboundFlg
 */
export interface InternalInboundFlg {
}

/**
 * Check if a given object implements the InternalInboundFlg interface.
 */
export function instanceOfInternalInboundFlg(value: object): value is InternalInboundFlg {
    return true;
}

export function InternalInboundFlgFromJSON(json: any): InternalInboundFlg {
    return InternalInboundFlgFromJSONTyped(json, false);
}

export function InternalInboundFlgFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalInboundFlg {
    return json;
}

export function InternalInboundFlgToJSON(json: any): InternalInboundFlg {
    return InternalInboundFlgToJSONTyped(json, false);
}

export function InternalInboundFlgToJSONTyped(value?: InternalInboundFlg | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

